import { trackForwardedComponent } from '../../../util/trackComponent.js';
import { Dropdown } from './Dropdown.js';
import './Dropdown.types.js';

var DropdownWithTracking = trackForwardedComponent(Dropdown, {
  addWrapper: true
});

export { DropdownWithTracking as Dropdown };
//# sourceMappingURL=external.js.map
